<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">اطلاعات ورود/خروج تجهیز بهفا</h5>
      <br />

      <br>
      <br>


      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> وضیعت </label>
          <select class="custom-select" [(ngModel)]="Filter_Type_Lap">
            <option value="1">تمام موارد</option>
            <option value="2">آزمایشگاه</option>
            <option value="3">سایت</option>
          </select>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">تاریخ دریافت شروع</label>
          <input type="text" #datepickerInputStart placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">تاریخ دریافت پایان</label>
          <input type="text" #datepickerInputEnd placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>

      </div>

      <div class="row">

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Code BEHFA</label>
          <input [(ngModel)]="Filter_Code" name="Filter_Code" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">گروه</label>
          <select (change)="Read_Second_Device_Group()" name="First_Device_Group_Selected"
            [(ngModel)]="First_Device_Group_Selected" class="custom-select">
            <option value="0">همه موارد</option>
            <option *ngFor="let item of DataList_First_Device_Group" [value]="item.id">{{item.title}}</option>
          </select>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">زیر گروه</label>
          <select [(ngModel)]="Second_Device_Group_Selected" name="Second_Device_Group_Selected" class="custom-select">
            <option value="0">همه موارد</option>
            <option *ngFor="let item of DataList_Second_Device_Group" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
      </div>

      <div class="row">

        <div class="form-group col-md-9">
          <button *ngIf="!Procssing" type="button"
            (click)="ReadData_DeviceBehfa(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info"
            style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>

          <button *ngIf="!Procssing" (click)="exportexcel()" type="button" class="btn btn-warning"
            style="margin-left: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>

          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>

      </div>



      <br>
      <br>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Description</th>
              <th>Manufacturer</th>
              <th>Model</th>
              <th>Code BEHFA</th>
              <th>کارکرد (ساعت)</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_DeviceBehfa
            | paginate
                    : {
                        id: 'DataList_DeviceBehfaTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_DeviceBehfa).length
                      }
            ">
              <td>{{DataList_DeviceBehfa.indexOf(item)+1}}</td>
              <td class="EnglishClm">{{item.description}}</td>
              <td class="EnglishClm">{{item.manufacturer}}</td>
              <td class="EnglishClm">{{item.model}}</td>
              <td class="EnglishClm">{{item.codeBEHFA}}</td>
              <td>{{item.performance}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_DeviceBehfaTable" nextLabel="بعدی" previousLabel="قبلی"
      (pageChange)="page = $event"></pagination-controls>
  </div>
</div>


<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>#</th>
      <th>Description</th>
      <th>Manufacturer</th>
      <th>Model</th>
      <th>Code BEHFA</th>
      <th>کارکرد (ساعت)</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_DeviceBehfa">
      <td>{{DataList_DeviceBehfa.indexOf(item)+1}}</td>
      <td class="EnglishClm">{{item.description}}</td>
      <td class="EnglishClm">{{item.manufacturer}}</td>
      <td class="EnglishClm">{{item.model}}</td>
      <td class="EnglishClm">{{item.codeBEHFA}}</td>
      <td>{{item.performance}}</td>
    </tr>
  </tbody>
</table>